/** Vertical Main Menu ids for HCP profile in customer request flow (FormSections). */
export const HCP_PROFILE_REQUEST_TAB_IDS = {
  personal: 'hcp_req_profile_personal',
  address: 'hcp_req_profile_address',
  license: 'hcp_req_profile_license',
  education: 'hcp_req_profile_education',
};
